// =============================================================================
// makeChild — factory for a blank child object
// =============================================================================
// Single source of truth shared by RequestWizard and RequestForm.
// =============================================================================

export function makeChild(idx) {
  return {
    _key: `c${Date.now()}_${idx}`,
    gender: "",
    yearLevel: "",
    schoolName: "",
    // schools.id of the picked school (BYOD gate, db-198/db-199); null for a
    // free-typed / "Other" / chip / TAFE choice, and for grandfathered old drafts.
    schoolId: null,
    feesOpen: false,
    fees: [],
    uniforms: null,
    shoes: null,
    laptop: null,
  };
}
